var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('header-component',{attrs:{"content-props":{
      hasUserMenu: true,
      hasSearch: true,
      hasDiscoverMenu: true,
      hasLibraryLink: true,
      hasHighlightsLink: true
    }}}),_vm._v(" "),_c('cancellation-survey-header',{attrs:{"is-leaving-mup":_vm.isLeavingMup}}),_vm._v(" "),_c('div',{staticClass:"cancellation-survey__container"},[_c('cancellation-survey-form',{staticClass:"cancellation-survey__form",attrs:{"eligible-for-churn-prevention":_vm.eligibleForChurnPrevention,"is-leaving-mup":_vm.isLeavingMup,"survey-options":_vm.surveyOptions,"sku":_vm.sku}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }